import React from 'react'

import PropTypes from 'prop-types'
import { filter, map, get } from 'lodash'
import AssetRow from './AssetRow'

const AssetsTable = ({ assetRuleType, category }) => {
  let { assets } = assetRuleType

  if (category) {
    assets = filter(assetRuleType.assets, { calligo_device_type: get(category, 'label', 'Unknown') })
  }

  return (
    <table>
      <thead>
        <tr>
          <th>Asset</th>
          <th>Antivirus</th>
          <th>Monitoring</th>
          <th>Patching</th>
          <th>Data Protection</th>
        </tr>
      </thead>
      <tbody>
        {map(assets, asset => (
          <AssetRow {...{
            asset,
            falseColor: assetRuleType.falseColor,
            trueColor: assetRuleType.trueColor
          }}
          />
        ))}
      </tbody>
    </table>
  )
}

AssetsTable.defaultProps = {
  assetRuleType: []
}

export default AssetsTable
